import { createAsyncThunk } from '@reduxjs/toolkit';
import { redirect } from 'react-router';

import type { RootState } from 'src/app/store/types';
import { enhancedBambiApi } from 'src/common/external/bambi-api/enhancedBambiApi';
import { show } from 'src/common/primitives/Toast/toast.slice';

import { dispatcherSlice } from './dispatcher.slice';
import { getExcludedIds } from './RunBambiRunRoute/RunBambiRunReview/getExcludedIds';

export const onApplyRunBambiRun = createAsyncThunk(
  'dispatcher/runBambiRun/apply',
  async function onApplyRunBambiRunImpl(
    {
      rbrJobId,
    }: {
      rbrJobId: string;
    },
    { dispatch, getState }
  ) {
    // Not sure why getState is unknown here
    // It's a valid member of the thunkAPI/payloadCreator
    // See https://redux-toolkit.js.org/api/createAsyncThunk#payloadcreator
    // @ts-ignore
    const currentState: RootState = getState() as RootState;
    const {
      dispatcher: {
        tripAssignmentsToApplyIds,
        runBambiRunResult,
        selectedDate,
      },
    } = currentState;

    dispatch(dispatcherSlice.actions.startRunBambiRunApply());
    try {
      if (!runBambiRunResult) {
        throw new Error('No Run Bambi Run Result found');
      }
      const applyPromise = dispatch(
        enhancedBambiApi.endpoints.runBambiRunApplyCreate.initiate({
          id: rbrJobId,
          runBambiRunApply: {
            excluded_trips: getExcludedIds(
              runBambiRunResult.new_trip_assignments,
              tripAssignmentsToApplyIds
            ),
          },
        })
      );
      await applyPromise;
      dispatch(
        show({
          description: 'Run Bambi Run applied successfully',
          type: 'success',
        })
      );
      redirect(`/dispatch/${selectedDate}`);
    } catch (e) {
      console.error(`RBR Apply Error:`, e);
      dispatch(
        show({
          description: 'Error applying Run Bambi Run',
          type: 'error',
        })
      );
    }
    dispatch(dispatcherSlice.actions.endRunBambiRunApply());
  }
);
